import { render } from "./DigiQMenuBar.vue?vue&type=template&id=0442d6a5"
import script from "./DigiQMenuBar.vue?vue&type=script&lang=js"
export * from "./DigiQMenuBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__